export type { GatewayModelId } from './gateway-language-model-settings';
export type { GatewayRerankingModelId } from './gateway-reranking-model-settings';
export type { GatewaySpeechModelId } from './gateway-speech-model-settings';
export type { GatewayTranscriptionModelId } from './gateway-transcription-model-settings';
export type { GatewayVideoModelId } from './gateway-video-model-settings';
export type {
  GatewayLanguageModelEntry,
  GatewayLanguageModelSpecification,
} from './gateway-model-entry';
export type { GatewayCreditsResponse } from './gateway-fetch-metadata';
export type {
  GatewaySpendReportParams,
  GatewaySpendReportRow,
  GatewaySpendReportResponse,
} from './gateway-spend-report';
export type {
  GatewayGenerationInfoParams,
  GatewayGenerationInfo,
} from './gateway-generation-info';
export type { GatewayLanguageModelEntry as GatewayModelEntry } from './gateway-model-entry';
export {
  createGatewayProvider,
  createGatewayProvider as createGateway,
  gateway,
} from './gateway-provider';
export type {
  GatewayProvider,
  GatewayProviderSettings,
} from './gateway-provider';
export type {
  GatewayProviderOptions,
  /** @deprecated Use `GatewayProviderOptions` instead. */
  GatewayProviderOptions as GatewayLanguageModelOptions,
} from './gateway-provider-options';
export {
  GatewayError,
  GatewayAuthenticationError,
  GatewayFailedDependencyError,
  GatewayForbiddenError,
  GatewayInvalidRequestError,
  GatewayRateLimitError,
  GatewayModelNotFoundError,
  GatewayInternalServerError,
  GatewayResponseError,
} from './errors';
export type { GatewayErrorResponse } from './errors';
